import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
// import Toggle from 'react-toggle';
import classNames from 'classnames';
import Clipboard from 'clipboard';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { fetchRegistry } from '../../../actions/RegistryActions';
import { fetchGuestList } from '../../../actions/GuestActions';
import { showModal } from '../../../actions/ModalActions';
import fetchModuleGroup from '../../../actions/ModuleGroupActions';
import { togglePage, fetchPages, fetchHiddenPageSuggestions } from '../../../actions/website/PageActions';
import { updateWeddingAccount, toggleWebsite } from '../../../actions/WeddingActions';
// import NavItem from '../../common/ui/NavItem';
import WebsiteSlug from './entities/WebsiteSlug';
import ManageWebsiteActions from './entities/ManageWebsiteActions';
import WebsiteNav from '../../common/header/SecondaryNav/SecondaryNav';
import { manageNavItems, weddingWebsiteNavItems } from '../../common/header/SecondaryNav/secondaryNavData';
import '../../../stylesheets/pages/EditPage.less';
import featureFlags from '../../../util/featureFlags';
import inOptimizelyExperiment from '../../../util/optimizelyHelper';
import { testPublishWebsiteInviteRedirectVariationA, testPublishWebsiteInviteRedirectVariationB } from '../../../util/optimizelyConfigs';


class ManagePages extends Component {
  constructor(props) {
    super(props);
    this.handlePasscodeToggle = this.handlePasscodeToggle.bind(this);
    this.toggleWebsitePublish = this.toggleWebsitePublish.bind(this);
    this.initiateOptimizelyTest = this.initiateOptimizelyTest.bind(this);
    this.state = {
      copyCta: 'Copy Link',
      copyLinkDisabled: false,
      clipboard: undefined,
      isClipboardSupported: Clipboard.isSupported()
    };
  }

  componentDidMount() {
    const {
      pages,
      hasRegistry,
      getPages,
      getRegistry,
      getGuestList,
      getModules,
      registry,
    } = this.props;

    if (pages.orderedIds.length === 0) {
      getPages();
    }

    // if registry status doesn't exist, that means registry info has not been fetched yet
    if (hasRegistry && !registry.status) {
      getRegistry();
    }

    getGuestList();
    getModules();

    this.initializeClipboard();

    if (window.zolaNav) {
      window.zolaNav.setTopLinkActive();
    }
  }

  componentWillUnmount() {
    this.destroyClipboard();
  }

  initializeClipboard() {
    const clipboard = new Clipboard('#website-slug__copy-text');

    clipboard.on('success', () => {
      this.setState({
        copyCta: 'Copied!',
        copyLinkDisabled: true
      });
      setTimeout(() => {
        this.setState({
          copyCta: 'Copy Link',
          copyLinkDisabled: false
        });
      }, 1500);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  handlePasscodeToggle() {
    const { account, onEnablePasscode, onDisablePasscode } = this.props;
    if (account.enable_passcode) {
      onDisablePasscode(account);
    } else {
      onEnablePasscode();
    }
  }

  initiateOptimizelyTest() {
    // manual trigger for optimizely - triggers the test on button click
    window['optimizely'] = window['optimizely'] || []; // eslint-disable-line
    window['optimizely'].push({ // eslint-disable-line
      type: 'page',
      pageName: 'web_actions_for_manage_cms_designs_pages'
    });
  }

  toggleWebsitePublish() {
    const { onTogglePublish, openHidePagesModal, account, onPublishWebsiteVA, onPublishWebsiteVB, onPublishWebsite, registry, weddingThemeKey, getHiddenPageSuggestions } = this.props;
    if (featureFlags.get('invitesModalRedirectTest')) {
      // get updated hidden page suggestion list and filter it by whether its hidden already
      this.initiateOptimizelyTest();
      getHiddenPageSuggestions().then((hiddenPageSuggestions) => {
        const hiddenPageResponse = hiddenPageSuggestions.payload.hiddenSuggestions;
        const hiddenPageList = _.omitBy(hiddenPageResponse, page => (
          page.hidden || (page.type === 'REGISTRY' && registry.is_public)
        ));
        // no hidden page suggestions and we're in Variation A - skip hidden pages, trigger Invites Redirect Modal
        if (_.isEmpty(hiddenPageList) && inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationA)) {
          onPublishWebsiteVA(weddingThemeKey);
          // no hidden page suggestions and we're in Variation B - skip hidden pages, trigger Invites CTA Modal
        } else if (_.isEmpty(hiddenPageList) && inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationB)) {
          onPublishWebsiteVB(weddingThemeKey);
        // there are hidden page suggestions, don't trigger either test modal regardless of test outcomes, trigger hidden page modal
        } else if ((!_.isEmpty(hiddenPageList) && (inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationA)))) {
          openHidePagesModal();
          // no hidden page suggestions and user is in control group - trigger old publish flow
        } else if ((!_.isEmpty(hiddenPageList) && (inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationB)))) {
          openHidePagesModal();
          // no hidden page suggestions and user is in control group - trigger old publish flow
        } else if (_.isEmpty(hiddenPageList) && ((!inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationA)) && (!inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationB)))) {
          onPublishWebsite(true);
          // there are hidden page suggestions and user is on control group - trigger hidden pages modal.
        } else if (!_.isEmpty(hiddenPageList) && ((!inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationA)) && (!inOptimizelyExperiment(testPublishWebsiteInviteRedirectVariationB)))) {
          openHidePagesModal();
        }
      });
      return;
    }
    if (account.published) {
      onTogglePublish(false);
    } else {
      openHidePagesModal();
    }
  }

  render() {
    const {
      pages,
      moduleGroup,
      openReorderPagesModal,
      slug,
      shareInfo,
      pageKey,
      published,
    } = this.props;

    const {
      copyCta,
      copyLinkDisabled,
      isClipboardSupported
    } = this.state;

    const longSlugName = slug && slug.length > 20;
    return (
      <div>
        <Helmet
          defaultTitle="Zola Weddings"
        />
        {
          window.zola.feature.newUnifiedNav
            ? <span className="visible-md-block visible-lg-block"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={weddingWebsiteNavItems} altActive={false} /></span>
            : <span className="visible-md-block visible-lg-block"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={manageNavItems} altActive={false} /></span>
        }
        <span className="hidden-md hidden-lg"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={weddingWebsiteNavItems} altActive={false} /></span>
        <div
          className={classNames(
            'manage-website',
            'manage-website__container'
          )}
        >
          <div>
            <div className="row">
              <h1 className="page-heading col-sm-6">Manage Website</h1>
              <ManageWebsiteActions
                slug={slug}
                published={published}
                pageKey={pageKey}
                publishWebsite={this.toggleWebsitePublish}
              />
            </div>
            <WebsiteSlug
              longSlugName={longSlugName}
              slug={slug}
              published={published}
              copySlug={this.copySlug}
              copyCta={copyCta}
              copyLinkDisabled={copyLinkDisabled}
              isClipboardSupported={isClipboardSupported}
            />
            <div className="manage-section">
              <div className="manage-panel website-pages">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="manage-panel-header">
                      <div className="title">
                        <span className="manage-website-label">Website Pages</span>
                      </div>
                      <div className="body">
                        <p>
                          Click on any of the pages below to edit it. Want to switch around the order of your pages?
                          <a role="button" onClick={openReorderPagesModal} className="text-button">Reorder Pages &rsaquo;</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 manage-panel-content">
                    <div className="pages">
                      <div className="row">
                        {pages.orderedIds.map(id => (
                          <div key={id} className={`col-xs-4 col-sm-3 col-lg-2 page ${pages.byId[id].type.toLowerCase()}`}>
                            <Link to={`/wedding/manage/website/pages/${pages.byId[id].type.toLowerCase()}`} className={`${pages.byId[id].type.toLowerCase()} manage-page-module-link`}>
                              <i className={`zolaicon zolaicon-${pages.byId[id].type.toLowerCase()}`} />
                              <div className="page-title">{pages.byId[id].menu_title}</div>
                              <div className="text-muted" style={{ visibility: pages.byId[id].hidden ? '' : 'hidden' }}>
                                <em>(Hidden)</em>
                              </div>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="website-modules">
              {moduleGroup.moduleViews && (
                <div id="weddings-manage-pages-marketing-modules" className="row">
                  {moduleGroup.moduleViews.map((moduleView, idx) => (
                    <div className="col-xs-12 col-md-6 marketing-module" key={idx}>
                      <a href={moduleView.link_path} rel="noopener noreferrer">
                        <img src={moduleView.images_by_dimension['590x300']} alt={moduleView.title} className="img-responsive" />
                      </a>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ManagePages.propTypes = {
  account: PropTypes.shape({}),
  hasRegistry: PropTypes.bool,
  pages: PropTypes.shape({}),
  moduleGroup: PropTypes.shape({}),
  getRegistry: PropTypes.func,
  getGuestList: PropTypes.func,
  getPages: PropTypes.func,
  getModules: PropTypes.func,
  onTogglePublish: PropTypes.func,
  onEnablePasscode: PropTypes.func,
  onDisablePasscode: PropTypes.func,
  openReorderPagesModal: PropTypes.func,
  openHidePagesModal: PropTypes.func,
  slug: PropTypes.string,
  published: PropTypes.bool,
  shareInfo: PropTypes.shape({}),
  pageKey: PropTypes.string,
  registry: PropTypes.shape({}),
  getHiddenPageSuggestions: PropTypes.func.isRequired,
  onPublishWebsiteVA: PropTypes.func.isRequired,
  onPublishWebsiteVB: PropTypes.func.isRequired,
  weddingThemeKey: PropTypes.string,
  onPublishWebsite: PropTypes.func
};

const mapStateToProps = state => ({
  wedding: state.wedding.wedding,
  account: state.wedding.account,
  hasRegistry: state.user.userContext.has_registry,
  registry: state.registry,
  theme: state.wedding.theme,
  guestGroups: state.guestList.guests.byId,
  pages: state.website.pages,
  moduleGroup: state.moduleGroup['weddings-manage-pages'] || {},
  slug: state.wedding.wedding.slug,
  published: state.wedding.account.published,
  themeGroupTitle: state.wedding.themeGroupTitle,
  hideablePages: state.website.pages.hideablePagesById,
  weddingThemeKey: state.wedding.theme.key
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getRegistry: () => dispatch(fetchRegistry()),
  getModules: () => dispatch(fetchModuleGroup('weddings-manage-pages')),
  getGuestList: () => dispatch(fetchGuestList()),
  getPages: () => dispatch(fetchPages()),
  getHiddenPageSuggestions: () => dispatch(fetchHiddenPageSuggestions()),
  onTogglePublish: publish => dispatch(toggleWebsite(publish)),
  openHidePagesModal: () => dispatch(showModal('HIDE_PAGES', {}, { size: 'md' })),
  onEnablePasscode: () => dispatch(showModal('WEBSITE_SETTINGS', { enablePasscode: true }, { size: 'md' })),
  onDisablePasscode: (account) => {
    const accountRequest = Object.assign({}, account, { enable_passcode: false, passcode: undefined, passcode_instructions: undefined });
    return dispatch(updateWeddingAccount(accountRequest));
  },
  onTogglePage: id => dispatch(togglePage(id)),
  showErrorModalv2: () => dispatch(showModal('PUBLISH_PAGE_ERROR', {
    heading: 'Want guests to RSVP on your wedding website?',
    body: 'First, create an event and build a guest list for it. Then you\'ll be able to unhide this page and let guests RSVP on this page',
    button: {
      text: 'Create An Event',
      action: () => browserHistory.push('/wedding/manage/events')
    } }, { size: 'md' })),
  showSuccessModal: () => dispatch(showModal('PUBLISH_RSVP', {}, { size: 'md' })),
  openReorderPagesModal: () => dispatch(showModal('REORDER_PAGES', {}, { size: 'md' })),
  openWebsiteSettingsModal: () => dispatch(showModal('WEBSITE_SETTINGS', {}, { size: 'md' })),
  openShare: (wedding) => {
    dispatch(showModal('SHARE', { wedding }, { size: 'md' }));
  },
  // control publish modal action creator
  onPublishWebsite: publish => dispatch(toggleWebsite(publish)).then(() => { dispatch(showModal('PUBLISH_WEBSITE', {}, { size: 'md' })); }).then(() => {
    if (ownProps.afterPublish) {
      return ownProps.afterPublish();
    }
    return false;
  }),
  publishWebsite: (published) => {
    if (published) {
      dispatch(toggleWebsite(false));
    } else {
      dispatch(showModal('HIDE_PAGES', {}, { size: 'md' }));
    }
  },

  // redirect test publish modal action creator
  onPublishWebsiteVA: () => dispatch(toggleWebsite(true)).then(() => {
    if (ownProps.afterPublish) {
      return ownProps.afterPublish();
    }
    return dispatch(showModal('INVITE_REDIRECT_MODAL_VARIATION_A', { disableClose: true, hideClose: true }, { size: 'md' }));
  }),
  onPublishWebsiteVB: () => dispatch(toggleWebsite(true)).then(() => {
    if (ownProps.afterPublish) {
      return ownProps.afterPublish();
    }
    return dispatch(showModal('INVITE_REDIRECT_MODAL_VARIATION_B', {}, { size: 'md' }));
  }),

  openDomainModal: () => dispatch(showModal('CUSTOM_DOMAIN_MODAL', {}, { size: 'md' })),
  openDomainCompltionModal: () => dispatch(showModal('CUSTOM_DOMAIN_COMPLETION_MODAL', {}, { size: 'md' }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagePages);



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePages.jsx